import "./ProgressBarInner.css";

const ProgressBarInner = ({ totalItems, discountTier }) => {
  return (
    <div className="progress-bar">
      <div
        className="progress-bar-inner"
        style={{
          width: `${
            totalItems === 0 ? 0 : ((totalItems - 1) / Object.keys(discountTier).length) * 100
          }%`,
        }}></div>
    </div>
  );
};

export default ProgressBarInner;
